import { apiGet, apiPost, apiPut, apiDelete } from './api';
import API_CONFIG from '../config/api';

const { ENDPOINTS } = API_CONFIG;

export const AfiliacionesService = {
  /** Precio de afiliación que aplica al usuario actual (según edad y club). */
  async getPrecioAfiliacion() {
    const response = await apiGet(ENDPOINTS.AFILIACION.PRECIO);
    const data = await response.json();
    if (data.ok === false) throw new Error(data?.mensaje || 'Error al obtener precio');
    return data;
  },

  async listarAdmin(page = 1, limit = 10, search = '') {
    try {
      let url = `${ENDPOINTS.AFILIACION.LISTAR}?page=${page}&limit=${limit}`;
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      
      const response = await apiGet(url);
      const data = await response.json();

      if (data.ok === false || data.success === false) {
        throw new Error(data?.mensaje || data?.error || data?.message || 'Error al listar afiliaciones');
      }

      // Retornar datos con paginación
      return {
        items: data.items || [],
        pagination: data.pagination || {
          page: 1,
          limit: 10,
          total: data.items?.length || 0,
          total_pages: 1,
          has_next: false,
          has_prev: false
        }
      };
    } catch (error) {
      console.error('Error en listarAdmin:', error);
      throw error;
    }
  },

  async crear(afiliacionData) {
    try {
      const response = await apiPost(ENDPOINTS.AFILIACION.CREAR, afiliacionData);
      const data = await response.json();

      if (data.ok === false || data.success === false) {
        throw new Error(data?.mensaje || data?.error || data?.message || 'Error al crear afiliación');
      }

      return data;
    } catch (error) {
      console.error('Error en crear afiliación:', error);
      throw error;
    }
  },

  async obtener(id) {
    try {
      const response = await apiGet(ENDPOINTS.AFILIACION.OBTENER(id));
      const data = await response.json();

      if (data.ok === false || data.success === false) {
        throw new Error(data?.mensaje || data?.error || data?.message || 'Error al obtener afiliación');
      }

      return data.afiliacion || data;
    } catch (error) {
      console.error('Error en obtener afiliación:', error);
      throw error;
    }
  },

  async editar(id, afiliacionData) {
    try {
      const response = await apiPut(ENDPOINTS.AFILIACION.EDITAR(id), afiliacionData);
      const data = await response.json();

      if (data.ok === false || data.success === false) {
        throw new Error(data?.mensaje || data?.error || data?.message || 'Error al editar afiliación');
      }

      return data;
    } catch (error) {
      console.error('Error en editar afiliación:', error);
      throw error;
    }
  },

  async eliminar(id) {
    try {
      const response = await apiDelete(ENDPOINTS.AFILIACION.ELIMINAR(id));
      const data = await response.json();

      if (data.ok === false || data.success === false) {
        throw new Error(data?.mensaje || data?.error || data?.message || 'Error al eliminar afiliación');
      }

      return data;
    } catch (error) {
      console.error('Error en eliminar afiliación:', error);
      throw error;
    }
  }
};
